/**
 * Hiring Team Member workspace (a scoped view invited by an employer).
 */
import React from "react";
import { Route, Navigate } from "react-router-dom";

import TeamLayout, { TeamDashboard } from "@/pages/team/TeamLayout";
import TeamCandidates from "@/pages/team/TeamCandidates";

export function teamRoutes() {
    return (
        <Route path="/team" element={<TeamLayout />}>
            <Route index element={<Navigate to="/team/dashboard" replace />} />
            <Route path="dashboard" element={<TeamDashboard />} />
            <Route path="candidates" element={<TeamCandidates />} />
        </Route>
    );
}
